/* tslint:disable */
/* eslint-disable */
/**
 * Melco Identity APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    IdentityMelcoModelsAuthorizeDiscount,
    IdentityMelcoModelsAuthorizeDiscountFromJSON,
    IdentityMelcoModelsAuthorizeDiscountToJSON,
    IdentityMelcoModelsBoolResponse,
    IdentityMelcoModelsBoolResponseFromJSON,
    IdentityMelcoModelsBoolResponseToJSON,
    IdentityMelcoModelsDiscountResponse,
    IdentityMelcoModelsDiscountResponseFromJSON,
    IdentityMelcoModelsDiscountResponseToJSON,
    IdentityMelcoModelsError,
    IdentityMelcoModelsErrorFromJSON,
    IdentityMelcoModelsErrorToJSON,
    IdentityMelcoModelsUserDiscount,
    IdentityMelcoModelsUserDiscountFromJSON,
    IdentityMelcoModelsUserDiscountToJSON,
} from '../models';

export interface DiscountsApiDiscountAuthorizeRequest {
    identityMelcoModelsAuthorizeDiscount?: IdentityMelcoModelsAuthorizeDiscount;
}

export interface DiscountsApiDiscountCalculateRequest {
    identityMelcoModelsUserDiscount?: IdentityMelcoModelsUserDiscount;
}

export interface DiscountsApiDiscountRedeemRequest {
    couponCode?: string;
}

export interface DiscountsApiDiscountRemoveRequest {
    couponCode?: string;
}

/**
 * 
 */
export class DiscountsApi extends runtime.BaseAPI {

    /**
     */
    async discountAuthorizeRaw(requestParameters: DiscountsApiDiscountAuthorizeRequest): Promise<runtime.ApiResponse<IdentityMelcoModelsBoolResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/coupons/authorize`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IdentityMelcoModelsAuthorizeDiscountToJSON(requestParameters.identityMelcoModelsAuthorizeDiscount),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => IdentityMelcoModelsBoolResponseFromJSON(jsonValue));
    }

    /**
     */
    async discountAuthorize(requestParameters: DiscountsApiDiscountAuthorizeRequest): Promise<IdentityMelcoModelsBoolResponse> {
        const response = await this.discountAuthorizeRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async discountCalculateRaw(requestParameters: DiscountsApiDiscountCalculateRequest): Promise<runtime.ApiResponse<IdentityMelcoModelsDiscountResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json-patch+json';

        const response = await this.request({
            path: `/coupons/calculate`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: IdentityMelcoModelsUserDiscountToJSON(requestParameters.identityMelcoModelsUserDiscount),
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => IdentityMelcoModelsDiscountResponseFromJSON(jsonValue));
    }

    /**
     */
    async discountCalculate(requestParameters: DiscountsApiDiscountCalculateRequest): Promise<IdentityMelcoModelsDiscountResponse> {
        const response = await this.discountCalculateRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async discountRedeemRaw(requestParameters: DiscountsApiDiscountRedeemRequest): Promise<runtime.ApiResponse<IdentityMelcoModelsBoolResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.couponCode !== undefined) {
            queryParameters['coupon_code'] = requestParameters.couponCode;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/coupons/redeem`,
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => IdentityMelcoModelsBoolResponseFromJSON(jsonValue));
    }

    /**
     */
    async discountRedeem(requestParameters: DiscountsApiDiscountRedeemRequest): Promise<IdentityMelcoModelsBoolResponse> {
        const response = await this.discountRedeemRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async discountRemoveRaw(requestParameters: DiscountsApiDiscountRemoveRequest): Promise<runtime.ApiResponse<IdentityMelcoModelsBoolResponse>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.couponCode !== undefined) {
            queryParameters['coupon_code'] = requestParameters.couponCode;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/coupons/remove`,
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => IdentityMelcoModelsBoolResponseFromJSON(jsonValue));
    }

    /**
     */
    async discountRemove(requestParameters: DiscountsApiDiscountRemoveRequest): Promise<IdentityMelcoModelsBoolResponse> {
        const response = await this.discountRemoveRaw(requestParameters);
        return await response.value();
    }

}
